import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Page, SearchBar } from 'components';
import { Results } from './components';
import Reload from '../../components/Reload/Reload';
import Header from 'components/Header/Header';
import { Button, Col, Row } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { loadState, saveState } from 'utils/persistState';
import { getAssistencias } from '../Assistencias/assistenciasApi';
import {
  hasCadastrosReadPermission,
  hasCadastrosWritePermission,
} from './assistenciasCadastrosUtils';
import { useAppTheme } from '../../contexts/ThemeContext';

const STORAGE_KEY = 'filters:assistencias-cadastros';

const AssistenciasCadastros = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('userData') || 'null');

  if (!hasCadastrosReadPermission(user)) {
    window.location.replace('/home');
  }

  const canWrite = hasCadastrosWritePermission(user);

  const [assistencias, setAssistencias] = useState([]);
  const [tempAssistencias, setTempAssistencias] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [loading, setLoading] = useState(true);

  const currentTheme = useAppTheme();

  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  const loadAssistencias = async () => {
    try {
      setLoading(true);
      const data = await getAssistencias();
      const sorted = [...data].sort((a, b) =>
        (a.nome || '').localeCompare(b.nome || '', 'pt-BR')
      );
      setAssistencias(sorted);
      setTempAssistencias(sorted);
    } catch (error) {
      console.error('Erro ao carregar assistências:', error);
      setAssistencias([]);
      setTempAssistencias([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAssistencias();
  }, []);

  const handleSearch = () => {
    if (!searchData.trim()) {
      setTempAssistencias(assistencias);
      return;
    }

    const term = searchData.toUpperCase();
    const filtered = assistencias.filter((item) =>
      ['nome', 'cidade', 'estado', 'email', 'emailhp', 'status'].some(
        (key) => item?.[key] && String(item[key]).toUpperCase().includes(term)
      )
    );
    setTempAssistencias(filtered);
  };

  useEffect(() => {
    handleSearch();
  }, [assistencias, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value);
  };

  return (
    <Page className="p-3" title="Cadastro de Assistências">
      <Header page="Cadastro de Assistências" />

      {loading && <Reload />}

      <Row>
        <Col xs={12} sm={8} md={6} lg={6} xl={6}>
          <SearchBar
            onSearch={handleSearch}
            onSearchData={handleSearchData}
            searchData={searchData}
          />
        </Col>

        <Col
          xs={12}
          sm={4}
          md={6}
          lg={6}
          xl={6}
          className="text-md-end text-center"
        >
          <Button
            className="ms-2 mt-2 mb-2"
            variant="success"
            disabled={!canWrite}
            onClick={() => history.push('/assistencias/add')}
          >
            <FaPlus className="me-1" />
            Nova assistência
          </Button>
        </Col>
      </Row>

      {!loading && tempAssistencias && (
        <Results
          data={tempAssistencias}
          currentTheme={currentTheme}
          canWrite={canWrite}
        />
      )}
    </Page>
  );
};

export default AssistenciasCadastros;
